import { render, staticRenderFns } from "./ConvertReservationButton.vue?vue&type=template&id=87765096&scoped=true"
import script from "./ConvertReservationButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConvertReservationButton.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87765096",
  null
  
)

export default component.exports